import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "Photos";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
    name,
    initialState,
    extraReducers: (builder) => {
        createExtraReducers(builder, extraActions);
    },
});

// exports

export const PhotosActions = { ...slice.actions, ...extraActions };
export const PhotosReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        LoadPhotoSearchDetails: [],
        InsertUpdateUspInmateInboxPhotoReadResponse: [],
        LoadPhotoResult: [],

    };
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;


    return {
        getLoadPhotoSearch: getLoadPhotoSearch(),
        loadInsertUpdateUspInmateInboxPhotoRead: loadInsertUpdateUspInmateInboxPhotoRead(),
        loadPhotoDetails: loadPhotoDetails(),
        GetPublicIP: GetPublicIP(),
        LoadPhotoLoginLog: LoadPhotoLoginLog()
    };

    function LoadPhotoLoginLog() {
        return createAsyncThunk(
            `${name}/LoadPhotoLoginLog`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Photos/PhotoLoginLog`, objData)
        );
    }

    function GetPublicIP() {
        return createAsyncThunk(
            `${name}/GetPublicIP`,
            async () =>
                await fetchWrapper.get(`${baseUrl}/Kiosk/Photos/GetPublicIP`)
        );
    }

    function getLoadPhotoSearch() {
        return createAsyncThunk(
            `${name}/getLoadPhotoSearch`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Photos/LoadInmateInboxPhoto`, objData)
        );
    }
    function loadInsertUpdateUspInmateInboxPhotoRead() {
        return createAsyncThunk(
            `${name}/loadInsertUpdateUspInmateInboxPhotoRead`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Photos/InsertUpdateUspInmateInboxPhotoRead`, objData)
        );
    }
    function loadPhotoDetails() {
        return createAsyncThunk(
            `${name}/loadPhotoDetails`,
            async ({ PhotoCommID }) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Photos/LoadKioskPhotoDetailsFromS3?PhotoCommID=${PhotoCommID}`)
        );
    }

}

function createExtraReducers(builder, actions) {
    builder
        .addCase(actions.getLoadPhotoSearch.pending, (state) => {
            //state.LoadPhotoSearchDetails = [];
        })
        .addCase(actions.getLoadPhotoSearch.fulfilled, (state, action) => {
            state.LoadPhotoSearchDetails = action.payload;
        })
        .addCase(actions.getLoadPhotoSearch.rejected, (state, action) => {
            state.LoadPhotoSearchDetails = { error: action.error };
        })
        .addCase(actions.loadInsertUpdateUspInmateInboxPhotoRead.pending, (state) => {
            state.InsertUpdateUspInmateInboxPhotoReadResponse = [];
        })
        .addCase(actions.loadInsertUpdateUspInmateInboxPhotoRead.fulfilled, (state, action) => {
            state.InsertUpdateUspInmateInboxPhotoReadResponse = action.payload;
        })
        .addCase(actions.loadInsertUpdateUspInmateInboxPhotoRead.rejected, (state, action) => {
            state.InsertUpdateUspInmateInboxPhotoReadResponse = { error: action.error };
        })
        .addCase(actions.loadPhotoDetails.pending, (state) => {
            state.LoadPhotoResult = [];
        })
        .addCase(actions.loadPhotoDetails.fulfilled, (state, action) => {
            state.LoadPhotoResult = action.payload;
        })
        .addCase(actions.loadPhotoDetails.rejected, (state, action) => {
            state.LoadPhotoResult = { error: action.error };
        });
}
